import { useState, useEffect } from "react";
import { Drawer, Button, useOverlayState } from "@heroui/react";
import { Users } from "lucide-react";
import AddMembersComp from "@/components/members/add-members-comp";

const AddMembersDrawer = ({ show, initialParticipants = [], onResp }) => {
  const [participants, setParticipants] = useState(initialParticipants);

  const state = useOverlayState({
    isOpen: show,
    onOpenChange: (isOpen) => {
      if (!isOpen) onResp("close", null);
    },
  });

  useEffect(() => {
    if (show) setParticipants(initialParticipants);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  function onConfirmClick() {
    onResp("confirm", participants);
  }

  return (
    <Drawer state={state}>
      <Drawer.Backdrop variant="blur" className="bg-black/30">
        <Drawer.Content placement="bottom">
          <Drawer.Dialog className="rounded-b-0 dark:bg-black pb-16">
            <Drawer.Handle />
            <Drawer.Header className="flex items-start gap-3">
              <Drawer.Heading className="flex flex-col gap-3">
                <div className="flex items-center gap-3">
                  <div className="size-10 flex items-center justify-center rounded-full bg-accent-soft text-accent dark:bg-[#FFFFFF21] shrink-0">
                    <Users size={18} />
                  </div>
                  <span className="text-2xl font-black leading-[28px] text-accent">Add Members</span>
                </div>

                <span className="text-sm text-muted">Pick people to add.</span>
              </Drawer.Heading>
            </Drawer.Header>

            <Drawer.Body className="pb-6 flex flex-col gap-4 relative z-10">
              <AddMembersComp open={show} participants={participants} onChange={setParticipants} />
            </Drawer.Body>

            <Drawer.Footer className="gap-3 relative z-10">
              <Button onPress={() => onResp("close", null)} className="w-1/3 bg-background text-foreground">
                Cancel
              </Button>
              <Button onPress={onConfirmClick} className="w-full" variant="primary">
                Add {participants.length > 0 ? `(${participants.length})` : ""}
              </Button>
            </Drawer.Footer>

            <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-40 drawer-blob" />
          </Drawer.Dialog>
        </Drawer.Content>
      </Drawer.Backdrop>
    </Drawer>
  );
};

export default AddMembersDrawer;